import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useObjectTypeId } from './useObjectTypeId';

/**
 * @deprecated This hook is used to provide object type to legacy inputs for backwards compatibility.
 */
export const useObjectType = () => {
  const objectTypeId = useObjectTypeId();
  return denormalizeTypeId(objectTypeId);
};